import { type FC } from "react";
import Modal from "@root/shared/components/Modal";
import { Link } from "@root/shared/components/Link";
import { Button } from "@root/shared/components/Button";
import { EntryNote } from "@clientFrontend/features/awardsEntry/components/EntryNote";
import * as styles from "./styles.css";

type ExampleAnswers = {
  question: string;
  answer: string | string[];
};

type Props = {
  isShow: boolean;
  onClose: () => void;
  onClick: () => void;
  sectionName: string;
  sectionDescription: string;
  exampleAnswers: ExampleAnswers[];
  entryNote: string[];
  entryUrl: string;
};

export const Presentation: FC<Props> = ({
  isShow,
  onClick,
  onClose,
  sectionName,
  sectionDescription,
  exampleAnswers,
  entryNote,
  entryUrl,
}) => {
  return (
    <>
      <Button type="button" theme="primary" className={styles.button} onClick={onClick}>
        {sectionName}
        <br />
        にエントリーする
      </Button>
      <Modal isShow={isShow} headerTitleStyle="none" onClose={onClose}>
        <div className={styles.modalInner}>
          <p className={styles.sectionName}>{sectionName}</p>
          <p className={styles.sectionDescription}>{sectionDescription}</p>
          <div className={styles.entryNoteWrapper}>
            <EntryNote entryNote={entryNote} />
          </div>
          <div className={styles.linkWrapper}>
            <Link
              theme="primary"
              href={entryUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
            >
              {sectionName}
              <br />
              にエントリーする
            </Link>
          </div>
          {exampleAnswers.map((example) => (
            <div key={example.question} className={styles.questionWrapper}>
              <p className={styles.question}>{example.question}</p>
              <div className={styles.answerWrapper}>
                <p className={styles.entryExample}>記入例</p>
                {Array.isArray(example.answer) ? (
                  <ul className={styles.list}>
                    {example.answer.map((item) => (
                      <li key={item} className={styles.dotListItem}>
                        {item}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className={styles.answer}>{example.answer}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
};
